<script>
import { mapGetters } from "vuex";
import { Btn } from "uiv";
import Resultado from "./Resultado";

export default {
  mixins: [Resultado],
  components: { Btn },
  computed: {
    ...mapGetters(["showConectores"]),
    rules() {
      return this.resultado.tarifa && this.resultado.tarifa.rules[this.getMonedaShow];
    },
  },
};
</script>

<template>
  <tr>
    <td></td>
    <td v-if="showConectores" v-html="resultado.proveedor_nombre" class="small text-muted"></td>
    <td v-if="showConectores" v-html="resultado.operador_nombre || '-'" class="small text-muted"></td>
    <td v-html="resultado.codigo" class="small text-muted"></td>
    <td v-html="resultado.nombre"></td>
    <td class="tarifa">
      <template v-if="rules">
        <small v-text="rules.moneda"></small>
        <span v-text="rules.tarifa"></span>
      </template>
      <div v-else class="text-center">-</div>
    </td>
    <td>
      <btn
        :href="resultado.url_reservar"
        type="warning"
        size="sm"
        v-html="'Ver m&aacute;s'"
      />
    </td>
  </tr>
</template>

<style lang="scss" scoped>
.panel {
  > .table {
    > tbody {
      tr {
        > th {
          border: 0;
          background: #e6e9ed;
          padding: 12px 10px;
        }

        > td {
          padding: 12px 10px;
          vertical-align: middle;
          vertical-align: middle;

          &:last-child {
            width: 105px;
            text-align: right;
          }
        }
      }
    }
  }
}
</style>